import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { useDeleteStatusFlagMutation } from "app/services/api/statusFlagsApi";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";

export const useHandleDeleteFlag = (onSuccess?: () => void) => {
  const { showNewToast, showErrorToast } = useDisplayToast();

  const [triggerDeleteFlag, { isLoading: isDeleting }] =
    useDeleteStatusFlagMutation();

  const handleDeleteFlag = async ({ id }: Pick<StatusFlagModel, "id">) => {
    try {
      await triggerDeleteFlag({ flag: id }).unwrap();
      showNewToast({
        title: "Status flag deleted!",
        message: "The status flag was successfully deleted.",
        type: "success",
      });
      onSuccess?.();
    } catch (e) {
      showErrorToast(e);
    }
  };

  return {
    isDeleting,
    handleDeleteFlag,
  };
};
